import React from "react";
import { useLottie } from "lottie-react";
import data_not_found from "../Utils/data_not_found.json";

const DataNotFoundView = ({ height = 300, width = "100%" }) => {
  const options = {
    animationData: data_not_found,
    loop: true,
    style: {
      height,
      width,
      pointerEvents: "none",       // ✅ Allow scroll to pass through the animation
      touchAction: "manipulation", // ✅ Support touch-based scrolling on mobile
    },
  };

  const { View } = useLottie(options);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        overflow: "auto",
        maxHeight: "100vh",              // ✅ Ensure vertical scroll if needed
        WebkitOverflowScrolling: "touch", // ✅ Smooth scroll on iOS
        padding: 20,
      }}
    >
      {View}
    </div>
  );
};

export default DataNotFoundView;
